module.exports = __webpack_public_path__ + "static/media/crane.5498bc13.svg";